var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"outil",attrs:{"id":"Chat"},on:{"click":function($event){return _vm.switchChat()}}},[_c('icon-base',{attrs:{"viewBox":"0 0 19 18","width":"19","height":"18"}},[_c('IconCAChat')],1),(!_vm.configured)?[_vm._v(" à configurer ")]:[_vm._v(" "+_vm._s(_vm.$t('centre_aide_btn_chat'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }